// extracted by css-extract-rspack-plugin
export default {"titleWrapper":"LoginModalTilte-module__titleWrapper","backIcon":"LoginModalTilte-module__backIcon"};